import React from 'react';

const SvgTo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="TO_svg__c">
        <stop stopColor="#DF101B" offset="0%" />
        <stop stopColor="#C00711" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TO_svg__b" fill="#fff">
        <use xlinkHref="#TO_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M8 0h8v10.667H0V0h28v20H0V0h8z"
        fill="#E20F1B"
        mask="url(#TO_svg__b)"
      />
      <path
        d="M9.333 4h2.343c.18 0 .324.143.324.327V6.34a.33.33 0 0 1-.324.327H9.333V9.01a.323.323 0 0 1-.327.323H6.994a.33.33 0 0 1-.327-.323V6.667H4.324A.323.323 0 0 1 4 6.34V4.327A.33.33 0 0 1 4.324 4h2.343V1.657c0-.179.143-.324.327-.324h2.012a.33.33 0 0 1 .327.324V4z"
        fill="url(#TO_svg__c)"
        mask="url(#TO_svg__b)"
      />
    </g>
  </svg>
);

export default SvgTo;
